import { ICta } from './cta';
import { Dealer } from './dealerLocator';
import { Image } from './image';
import { IBaseModal } from './modal';
import { IColor } from './package';
import { IReduxColor } from './vehicle';

export interface IRAQColor extends IColor {
  accentName?: string;
  accentImage?: Image;
  fabricImage?: Image;
}

export interface IRequestAQuoteData {
  pageContent: {
    labels: {
      [key: string]: string;
    };
    ctas?: {
      [key: string]: ICta;
    };
    featureToggles: {
      [key: string]: boolean;
    };
    modals: {
      [key: string]: IBaseModal;
    };
    informationForm: IInformationForm;
  };
  taxonomy: ITaxonomy[];
  vehicleData?: IRequestAQuoteVehicle;
}

export interface IADXEnhancedData {
  labels: {
    [key: string]: string;
  };
  ctas?: {
    [key: string]: ICta;
  };
  informationForm: IInformationForm;
  transactionType: string;
}

export interface IRequestAQuoteVehicle {
  inventory?: IInventoryInfo;
  photos?: string[];
  offersInfo: IOfferCardInfo;
  modelId: string;
  modelYear: number;
  modelSeries: string;
  modelMarketingName: string;
  drivetrain: string;
  engine: string;
  packages: string[];
  exteriorColor: IRAQColor;
  interiorColor: IRAQColor;
}

export interface IOfferCardInfo {
  vehicleCardImage: string;
  vehicleCardDisclaimer: {
    id: string;
    title: string;
    description: string;
  };
}
export interface IInventoryInfo {
  dealer: Dealer | null;
  msrp: string | null;
  numberOnSite: number;
  numberInTransit: number;
}
export interface IRAQConfiguration {
  modelSeries?: string;
  modelYear?: string;
  modelId?: string;
  dealerId?: string;
  hideDealerChange?: boolean;
  variant: VehicleSelectorType;
  disableForm?: boolean;
  vinNumber?: string;
}

export interface IRAQConfigurationBAP extends IRAQConfiguration {
  modelId?: string;
  exteriorColor?: IReduxColor;
  interiorColor?: IReduxColor;
  powertrain?: string;
  package?: string;
  variant: VehicleSelectorType.bap | VehicleSelectorType.savedConfig;
}

export interface IRAQConfigurationOffers extends IRAQConfiguration {
  modelId: string;
  offers: string[];
  variant: VehicleSelectorType.offers;
}
export interface IRAQConfigurationPE extends IRAQConfiguration {
  modelId: string;
  dealerId?: string;
  offers?: string[];
  variant: VehicleSelectorType.offers | VehicleSelectorType.basic;
}
export interface IRAQConfigurationInventory extends IRAQConfiguration {
  modelId: string;
  dealerId: string;
  exteriorColor: {
    code: string;
  };
  interiorColor: {
    code: string;
  };
  variant: VehicleSelectorType.inventory;
}

export interface IInformationForm {
  'first-name': IInputField;
  'last-name': IInputField;
  email: IInputField;
  'raq-zipcode': IInputField;
  phone: IInputField;
  comments: IInputField;
  terms: IInputField;
  submitText: string;
}

export interface IInputField {
  name: string;
  label: string;
  required?: IRequiredError | null;
  pattern: IPatternError | null;
  maxLength: number;
}

export interface IRequiredError {
  value: boolean;
  message: string;
}

export interface IPatternError {
  value: string;
  message: string;
}
export interface IVehicleTaxonomy {
  Results: ITaxonomy[];
}

export interface ITaxonomy {
  sitecoreId: string;
  taxonomyName: string;
  taxonomyVehicle: string | null;
  modelYear: string | null;
  defaultVehicleImage: string;
  defaultVehicleImageAlt: string;
  packages: IPackage[] | null;
  vehicles: ITaxonomy[];
  isCurrentModels: boolean;
  supplyMessage: string;
}

export interface IPackage {
  vehicleModel: string;
  packageName: string;
  packageDescription: string;
  packageImageUrl: string;
  packageImageAlt: string;
}

export enum VehicleSelectorType {
  basic = 'basic',
  paymentEstimator = 'paymentEstimator',
  offers = 'offers',
  bap = 'bap',
  inventory = 'inventory',
  savedConfig = 'savedConfig',
}

export interface ICardInformation {
  modelName: string;
  modelYear: string;
  msrp?: {
    value: number | string;
    disclaimer?: string;
    caption: string;
  };
}

export interface ICardInformationBasic extends ICardInformation {
  imgAlt?: string;
  img: string;
  description?: string;
}

export interface ICardInformationComplex extends ICardInformation {
  bullets?: string[];
  images?: string[];
  colors: IReduxColor[];
  captionTitle?: string;
  captionDescription?: string;
}

export interface IQuoteRequest {
  accessories?: IBAPAccessory[] | null;
  adobeTransactionId?: string;
  vehicleModelSeries: string;
  modelYear: string;
  modelId: string | null;
  exteriorColorCode: string;
  exteriorColorIdent: string;
  exteriorColorName: string;
  exteriorColorPriceDelta: string;
  interiorColorCode: string;
  interiorColorIdent: string;
  interiorColorName: string;
  modelMarketingName: string;
  totalAsConfigured: string;
  dealerId: string;
  localDealerName: string;
  vinNumber: string | null;
  offerId?: string[] | null;
  source: string;
  zipCode: string;
  shoppingTool: string;
  provider: string;
  tracking: {
    campaingName: string;
    shoppingTool: string;
  };
  addressScrubbing: boolean;
  userInfo: {
    __RequestVerificationToken: string;
    firstName: string;
    lastName: string;
    email: string;
    zipcode: string;
    phone?: string;
    comments?: string;
    terms: string;
  };
}

export interface IFormData {
  comments?: string;
  email: string;
  'first-name': string;
  'last-name': string;
  phone?: string;
  terms: boolean;
  'raq-zipcode': string;
}

export interface IBAPAccessory {
  Name: string;
  Price: number;
  Code: string;
  Type: 'E' | 'I';
}
